export default __webpack_public_path__ + "images/c937ddc095ec8a22363ff3e07eb3ba41.webp";